<template>
    <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="prefix + title">
        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">
                    <b-form-row>
                        <b-col cols="12" sm="6">
                            <lg-finder-page-pessoa id="finderPessoaBaixaList" label="Responsável:*"
                                :prefix="prefix + title + ' > '" title="Responsáveis" v-model="form.responsavel"
                                invalidFeedback="Informe um responsável!" :disabled="isVisualizar"
                                @onselect="handlePessoaSelect" />
                        </b-col>
                        <b-col cols="12" sm="6">
                            <lg-form-date label="Data:*" v-model="form.data" description="" :disabled="isVisualizar"
                                invalidFeedback="Data obrigatória!" />
                        </b-col>
                    </b-form-row>
                    <b-form-row class="mt-2">
                        <b-col cols="12" sm="6">
                            <LgFinderPageTipoBaixa id="finderTipoBaixa" @input="handleTipoBaixaSelect"
                                label="Tipo de Baixa:*" v-model="form.tipoBaixa" :prefix="[prefix + title]"
                                :disabled="isVisualizar" :isModal="true" />
                        </b-col>
                    </b-form-row>
                    <b-form-row class="mt-2">
                        <b-col cols="12" sm="6" class="d-flex justify-content-start">
                            <b-form-checkbox v-model="motivoGeralChecked" class="mr-2" :disabled="isVisualizar"
                                @change="handleMotivoGeral">
                                Motivo Geral
                            </b-form-checkbox>
                            <lg-form-textarea v-if="motivoGeralChecked" description=" " label="Observação:" cols="12"
                                :disabled="isVisualizar" v-model="form.motivoGeral" />
                        </b-col>
                    </b-form-row>
                </b-card>
                <b-card bg-variant="light" class="mt-3">
                    <b-form-row @keydown.enter="filtrar">
                        <b-col cols="9">
                            <b-row>
                                <b-col>
                                    <lg-form-input v-model="filters.tombamento" label="Tombamento:"
                                        placeholder="Tomb. inicial" />
                                </b-col>
                                <b-col>
                                    <lg-form-input v-model="filters.tombamentoAte" label="Até:"
                                        placeholder="Tomb. final" />
                                </b-col>
                                <b-col>
                                    <lg-form-input v-model="filters.tombamentoSamp" label="Tomb. SAMP:" />
                                </b-col>
                                <b-col>
                                    <lg-form-input v-model="filters.descricao" label="Descrição:" />
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="3" class="align-self-center">
                            <b-button id="limpar" class="mb-2 mr-2" size="sm" pill variant="primary"
                                @click="limparFiltros">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="eraser" />
                                </div>
                                <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                            </b-button>
                            <b-button id="localizar" class="mb-2 mr-2" size="sm" pill variant="primary"
                                @click="filtrar">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" />
                                </div>
                                <b-tooltip target="localizar" title="Localizar"></b-tooltip>

                            </b-button>
                            <b-button id="novo" class="mb-2 mr-2" size="sm" pill variant="secondary"
                                :disabled="isVisualizar" @click="showModalItens">
                                <div class="btn-size-alinhamento">
                                    <b-icon scale="1" icon="plus" />
                                </div>
                                <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                            </b-button>

                        </b-col>
                    </b-form-row>
                </b-card>
                <b-card bg-variant="light" class="mt-3">
                    <div style="overflow-x: auto; overflow-y: auto; max-height: 400px;">
                        <b-table responsive small :items="filteredItems" :fields="tableFields" :hover="true" show-empty>
                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>
                            <template #cell(motivo)="row" >
                                <lg-form-input  :disabled="isVisualizar" rows="3"
                                    v-model="row.item.motivo" />
                            </template>
                            <template #cell(destino)="row">
                                <lg-form-input  :disabled="isVisualizar" rows="3"
                                    v-model="row.item.destino" />
                            </template>
                            <template #cell(acoes)="row">
                                <b-button size="sm" variant="primary" :disabled="isVisualizar"
                                    @click="removeItem(row.index, row)" :id="row.index + 'remover-button'" class="my-2">
                                    <b-icon icon="trash" />
                                    <b-tooltip :target="row.index + 'remover-button'" title="Remover"></b-tooltip>
                                </b-button>
                            </template>
                            <template v-slot:cell(estornar)="row">
                                <b-button v-if="row.item.status === 'Baixado'" :id="row.index + 'estornar-button'"
                                    class="my-2" size="sm" pill variant="primary"
                                    @click="estornarIndividualmente(row.item)">
                                    <b-icon icon="arrow-left" />
                                    <b-tooltip :target="row.index + 'estornar-button'" title="Estornar..."></b-tooltip>
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </b-card>
            </b-card-body>
        </b-card>
        <b-form-row class="mt-2">
            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
                <b-button id="salvarBaixaItemBemPermanente" class="my-2" size="sm" pill v-if="!isVisualizar"
                    variant="success" @click="save">
                    <b-icon icon="check-circle" />
                    <b-tooltip :target="'salvarBaixaItemBemPermanente'" title="Salvar"></b-tooltip>
                </b-button>
                <b-button id="cancelarBaixaItemBemPermanente" class="my-2 ml-2" size="sm" pill variant="danger"
                    @click="cancelar">
                    <b-icon icon="x-circle" />
                    <b-tooltip :target="'cancelarBaixaItemBemPermanente'" title="Cancelar"></b-tooltip>
                </b-button>
            </b-col>
            <b-col cols="3"></b-col>
        </b-form-row>
        <ModalPageItemBemPermanente :title="prefix + title + ' > Item Bem Permanente'" v-if="showItens"
            @fecharModal="closeModalItens" @onselect="addItens" />
        <BaixaItemBemPermanenteEstornoForm v-if="showModalEstornoIndividual" :prefix="prefix"
            :title="'Cadastro > Estorno Baixa Item Bem Permanente'" :isIndividual="true"
            :id="idItemBemPermanenteEstorno" @close="fecharModalEstornoIndividual" />
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormTextarea from "@/core/components/Form/LgFormTextarea.vue";
import ModalPageItemBemPermanente from "@/core/components/Modals/ModalPageItemBemPermanente.vue";
import LgFinderPageTipoBaixa from "@/components/Finders/LgFinderPageTipoBaixa.vue";
import { BButton, BCard, BCardBody, BFormRow, BCol, BTable, BFormCheckbox, BIcon, BTooltip } from "bootstrap-vue";
import moment from "moment";
import BaixaItemBemPermanenteEstornoForm
    from "@/modules/patrimonio/baixa-item-bem-permanente/BaixaItemBemPermanenteEstornoForm.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import { required } from "vuelidate/lib/validators";

export default {
    name: "BaixaItemBemPermanenteForm",
    components: {
        BaixaItemBemPermanenteEstornoForm,
        LgFinderPageTipoBaixa,
        ModalPageItemBemPermanente,
        LgFinderPagePessoa,
        LgFormDate,
        LgFormInput,
        LgFormTextarea,
        BButton,
        BCard,
        BCardBody,
        BFormRow,
        BCol,
        BTable,
        BFormCheckbox,
        BIcon,
        BTooltip
    },
    props: {
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Cadastro"
        },
        id: {
            type: Number,
            default: null
        },
        isVisualizar: {
            type: Boolean,
            defualt: false
        }
    },
    mixins: [FormResourceMixin],
    validations: {
        form: {
            responsavel: { required },
            data: { required },
            itens: { required },
            tipoBaixa: { required }
        },
    },
    data() {
        return {
            form: {
                cod: null,
                data: null,
                datacriacao: null,
                respcriacao: "",
                situacao: null,
                codtipobaixa: null,
                tipoBaixa: null,
                codstatus: null,
                motivoGeral: "",
                responsavel: null,
                itens: [],
            },
            listaExclusao: [],
            showItens: false,
            showModal: true,
            motivoGeralChecked: false,
            filters: {
                tombamento: "",
                tombamentoAte: "",
                tombamentoSamp: "",
                descricao: ""
            },
            activeFilters: {
                tombamento: "",
                tombamentoAte: "",
                tombamentoSamp: "",
                descricao: ""
            },
            tableItems: [],
            tableFields: [
                { key: "tombSpalm", label: "Tomb. SPALM" },
                { key: "tombSamp", label: "Tomb. SAMP" },
                { key: "numero", label: "Número" },
                { key: "descricao", label: "Descrição" },
                { key: "motivo", label: "Motivo Específico", thStyle: { minWidth: '300px !important' } },
                { key: "destino", label: "Destino", thStyle: { minWidth: '300px !important' } },
                { key: "status", label: "Status" },
                { key: "naturezaDespesa", label: "Natureza de Despesa" },
                { key: "valorAtual", label: "Valor Atual" },
                { key: "acoes", label: " ", tdClass: "w-1" },
                { key: "estornar", label: " ", tdClass: "w-1" }
            ],
            loading: false,
            savedId: this.id,
            showModalEstornoIndividual: false,
            idItemBemPermanenteEstorno: null,
            fecharModalEstorno: false
        };
    },
    computed: {
        filteredItems() {
            const { tombamento, tombamentoAte, tombamentoSamp, descricao } = this.activeFilters;
            return this.tableItems.filter((item) => {
                if (tombamento && item.tombSpalm < tombamento) {
                    return false;
                }
                if (tombamentoAte && item.tombSpalm > tombamentoAte) {
                    return false;
                }
                if (tombamentoSamp && !item.tombSamp.includes(tombamentoSamp)) {
                    return false;
                }
                if (descricao && !item.descricao.toLowerCase().includes(descricao.toLowerCase())) {
                    return false;
                }
                return true;
            });
        }
    },
    async beforeMount() {
        this.$service = new ResourceService("/api/baixaitembempermanente");
    },
    async mounted() {
        if (this.id) {
            const { data } = await this.$service.findById(this.id);
            this.form.cod = data.cod;
            this.form.data = moment(data.data).format("YYYY-MM-DD");
            this.form.datacriacao = data.datacriacao;
            this.form.respcriacao = data.respcriacao;
            this.form.situacao = data.situacao;
            if (data.tipoBaixa) {
                this.form.codtipobaixa = data.tipoBaixa.id;
                this.form.tipoBaixa = data.tipoBaixa;
            }
            this.form.codstatus = data.codstatus;
            this.form.responsavel = data.pessoa;
            this.form.motivoGeral = data.motivoGeral || "";
            if (data.ibpbaixaibps && Array.isArray(data.ibpbaixaibps)) {
                this.tableItems = data.ibpbaixaibps.map(item => {
                    return {
                        tombSpalm: item.itemBemPermanente.s_numTombAntigo,
                        tombSamp: item.itemBemPermanente.numTombamento,
                        numero: (item.itemBemPermanente.itemRegEntrada &&
                            item.itemBemPermanente.itemRegEntrada.produto)
                            ? item.itemBemPermanente.itemRegEntrada.produto.numero
                            : "",
                        descricao: (item.itemBemPermanente.itemRegEntrada &&
                            item.itemBemPermanente.itemRegEntrada.produto)
                            ? item.itemBemPermanente.itemRegEntrada.produto.descricaoResumida
                            : "",
                        motivo: item.motivo || "",
                        destino: item.destinoitembempermanente || "",
                        status: item.status ? item.status.descricao : "",
                        naturezaDespesa: item.itemBemPermanente.naturezaDespesa
                            ? item.itemBemPermanente.naturezaDespesa.descricao
                            : "",
                        valorAtual: item.itemBemPermanente.valorOriginal,
                        itemId: item.itemBemPermanente.id
                    };
                });
                this.form.itens = data.ibpbaixaibps.map(item => ({
                    item: {
                        id: item.itemBemPermanente.id,
                        destino: item.destinoitembempermanente,
                        motivo: item.motivo
                    }
                }));
            }
        } else {
            this.form.situacao = 1;
        }
    },
    methods: {
        cancelar() {
            this.$emit("close");
        },
        closemodal() {
            this.showItens = false;
        },
        validateFormFields() {
            if (!this.form.responsavel || !this.form.responsavel.id) {
                this.$notify({
                    type: "danger",
                    message: "É necessário informar um responsável."
                });
                return false;
            }
            if (!this.form.tipoBaixa || !this.form.tipoBaixa.id) {
                this.$notify({
                    type: "danger",
                    message: "É necesário informar o tipo de baixa."
                });
                return false;
            }
            if (!this.form.data) {
                this.$notify({
                    type: "danger",
                    message: "É necessário informar uma data."
                });
                return false;
            }
            if (!this.form.itens || this.form.itens.length === 0) {
                this.$notify({
                    type: "danger",
                    message: "Selecione pelo menos um item."
                });
                return false;
            }
            return true;
        },
        async save() {

            if (!this.validateFormFields()) {
                return;
            }

            this.loading = true;
            this.form.itens = this.tableItems.map(item => ({
                item: {
                    id: item.itemId,
                    destino: item.destino,
                    motivo: item.motivo
                }
            }));
            const dataISO = moment(this.form.data).toISOString();
            let response;
            try {
                if (this.id) {
                    const payload = {
                        cod: this.form.cod,
                        data: dataISO,
                        codtipobaixa: this.form.tipoBaixa ? this.form.tipoBaixa.id : null,
                        pessoaId: this.form.responsavel ? this.form.responsavel.id : null,
                        sNumIsn: this.form.sNumIsn,
                        motivoGeral: this.motivoGeralChecked ? this.form.motivoGeral : "",
                        itens: this.form.itens.map(i => ({
                            itemId: i.item.id,
                            destino: i.item.destino || "",
                            motivo: i.item.motivo || ""
                        })),
                        listaExclusao: this.listaExclusao
                    };
                    response = await this.$service.put(this.id, payload);

                    if (response.status === 200) {
                        this.$notify({
                            type: "success",
                            message: "Salvo com sucesso"
                        });
                    }
                } else {
                    const payload = {
                        data: dataISO,
                        respcriacao: this.form.respcriacao,
                        codtipobaixa: this.form.tipoBaixa ? this.form.tipoBaixa.id : null,
                        sNumIsn: this.form.sNumIsn,
                        pessoaId: this.form.responsavel ? this.form.responsavel.id : null,
                        motivoGeral: this.motivoGeralChecked ? this.form.motivoGeral : "",
                        itens: this.form.itens.map(i => ({
                            itemId: i.item.id,
                            destino: i.item.destino || "",
                            motivo: i.item.motivo || ""
                        }))
                    };
                    response = await this.$service.save(payload);

                    if (response.status === 200) {
                        this.$notify({
                            type: "success",
                            message: "Salvo com sucesso"
                        });
                    }

                }
                if (response && response.data && response.data.id) {
                    this.savedId = response.data.id;
                }
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });
            }

            this.loading = false;
            this.$emit("close");
        },
        estornarIndividualmente(item) {
            this.idItemBemPermanenteEstorno = item.itemId;
            this.showModalEstornoIndividual = true;
        },
        fecharModalEstornoIndividual() {
            this.showModalEstornoIndividual = false;
            this.idItemBemPermanenteEstorno = null;
        },
        handlePessoaSelect(item) {
            this.form.responsavel = item;
        },
        handleTipoBaixaSelect(tipo) {
            this.form.tipoBaixa = tipo;
        },
        showModalItens() {
            this.showItens = true;
        },
        closeModalItens() {
            this.showItens = false;
        },
        handleMotivoGeral() {
            if (!this.motivoGeralChecked) {
                this.form.motivoGeral = "";
            }
        },
        addItens(itemNovo) {
            this.showItens = false;
            const found = this.form.itens.find(item => item.item.id === itemNovo.id);
            if (found) {
                this.$notify({
                    type: "danger",
                    message: "Item Bem Permanente já vinculado!"
                });
                return;
            }
            this.form.itens.push({ item: itemNovo, dataDevoluacao: "", motivo:"" });
            this.tableItems.push({
                tombSpalm: itemNovo.s_numTombAntigo,
                tombSamp: itemNovo.numTombamento,
                numero: itemNovo.numero
                    ? itemNovo.numero
                    : "",
                descricao: itemNovo.descricaoResumida
                    ? itemNovo.descricaoResumida
                    : "",
                motivo: "",
                destino: itemNovo.destinoitembempermanente || "",
                status: "",
                naturezaDespesa: "",
                valorAtual: itemNovo.valorOriginal,
                itemId: itemNovo.id
            });
        },
        removeItem(index, rowItem) {
            console.log(index, rowItem)
            if (this.id && rowItem.item.itemId) {
                this.listaExclusao.push(rowItem.item.itemId);
            }
            this.tableItems.splice(index, 1);
            this.form.itens = this.form.itens.filter(i => i.item.id !== rowItem.item.itemId);
        },
        filtrar() {
            this.activeFilters = { ...this.filters };
        },
        limparFiltros() {
            this.filters = {
                tombamento: "",
                tombamentoAte: "",
                tombamentoSamp: "",
                descricao: ""
            };
            this.activeFilters = { ...this.filters };
        }
    }
};
</script>

<style scoped></style>
